import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    ILoadAppointmentAction,
    ILoadAppointmentSuccessAction,
    ILoadAppointmentErrorAction,
} from '../actions/load-appointment-date';
import { IOrderTrackerState } from '../state';
import { initialState } from '../state/initial-state';
import { IOrderInfoProgress } from '../state/order-info';

export type LoadAppointmentAction
    = ILoadAppointmentAction |
    ILoadAppointmentSuccessAction |
    ILoadAppointmentErrorAction

const init = (state: IOrderTrackerState, action: LoadAppointmentAction) => ({
    ...state,
    orderInfo: {
        ...state.orderInfo,
        data: {
            ...state.orderInfo.data,
            progress: updateProductStatus(state.orderInfo.data.progress, action.uuid,
                action.status)
        }
    }
})

const success = (state: IOrderTrackerState, action: LoadAppointmentAction) => ({
    ...state,
    orderInfo: {
        ...state.orderInfo,
        data: {
            ...state.orderInfo.data,
            progress: updateProductData(state.orderInfo.data.progress,
                (action as ILoadAppointmentSuccessAction).data, action.status)
        }
    }
})

const failure = (state: IOrderTrackerState, action: LoadAppointmentAction) => ({
    ...state,
    orderInfo: {
        ...state.orderInfo,
        data: {
            ...state.orderInfo.data,
            progress: updateProductError(state.orderInfo.data.progress, action.status, action.uuid,
                (action as ILoadAppointmentErrorAction).error),
        }
    }
})

const updateProductStatus = (products: IOrderInfoProgress[], uuid, status) => {
    const newProduct = products.find((item) => item.uuid === uuid);
    const filteredProducts = products.filter((item) => item.uuid !== uuid);
    newProduct.appointmentData = { ...newProduct.appointmentData, status };
    filteredProducts.push(newProduct);
    return filteredProducts;
}

const updateProductError = (products: IOrderInfoProgress[], status, uuid, error) => {
    const newProduct = products.find((item) => item.uuid === uuid);
    const filteredProducts = products.filter((item) => item.uuid !== uuid);
    newProduct.appointmentData = { ...newProduct.appointmentData, error, status };
    filteredProducts.push(newProduct);
    return filteredProducts;
}

const updateProductData = (products: IOrderInfoProgress[], data, status) => {
    const newProduct = products.find((item) => item.uuid === data.uuid);
    const filteredProducts = products.filter((item) => item.uuid !== data.uuid);
    newProduct.appointmentData = {
        ...newProduct.appointmentData,
        status,
        data
    };
    filteredProducts.push(newProduct);
    return filteredProducts;
}

export const loadAppointmentDateReducer = createAsyncReducer(initialState, init, success, failure);
